import { createSlice } from "@reduxjs/toolkit";

export const loginSlice = createSlice({
  name: "login",
  initialState: {
    authData: null,
    userData: null,
    role: null,
    modules: [],
    storeId: null,
    storeName: null,
  },
  reducers: {
    saveAuthData: (state, action) => {
      state.authData = action.payload;
    },
    saveUserData: (state, action) => {
      state.userData = action.payload;
    },
    saveRole: (state, action) => {
      state.role = action.payload;
    },
    saveModule: (state, action) => {
      state.modules = action.payload;
    },
    resetData: (state) => {
      state.userData = null;
      state.authData = null;
    },
    setAccessToken: (state, action) => {
      state.authData = state.authData && {
        ...state.authData,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
      };
    },
    saveStoreData: (state, action) => {
      state.storeId = action.payload.storeId;
      state.storeName = action.payload.storeName;
    },
  },
});

export const {
  saveAuthData,
  saveUserData,
  resetData,
  setAccessToken,
  saveRole,
  saveModule,
  saveStoreData,
} = loginSlice.actions;

export default loginSlice.reducer;
